const detail = {
  invoiceInfo: [
    {
      name: 'supplierName',
      text: 'order.order_supplier-name'
    },
    {
      name: 'section',
      text: 'order.order_department'
    },
    {
      name: 'rep',
      text: 'order.order_rep'
    },
    {
      name: 'phone',
      text: 'common.input_phone-number',
      component: 'PhoneNumberInput'
    },
    {
      name: 'fax',
      text: 'common.input_fax-number',
      component: 'PhoneNumberInput'
    },
    {
      name: 'email',
      text: 'common.input_email'
    },
    {
      name: 'country',
      text: 'common.input_country',
      cols: Math.ceil((12 - 3) / 2),
      component: 'SelectCountry'
    },
    {
      name: 'postalCode',
      text: 'common.input_postal-code',
      cols: Math.ceil((12 - 3) / 2)
    },
    {
      name: 'region',
      text: 'common.input_region',
      cols: Math.ceil((12 - 3) / 2),
      component: 'SelectRegion'
    },
    {
      name: 'address1',
      text: 'common.input_address_1'
    },
    {
      name: 'address2',
      text: 'common.input_address_2'
    }
  ],
  receiverInfo: [
    {
      name: 'receiverName',
      text: 'order.order_suggested-receiving-location'
    },
    {
      name: 'phone',
      text: 'common.input_phone-number',
      component: 'PhoneNumberInput'
    },
    {
      name: 'country',
      text: 'common.input_country',
      cols: Math.ceil((12 - 3) / 2),
      component: 'SelectCountry'
    },
    {
      name: 'postalCode',
      text: 'common.input_postal-code',
      cols: Math.ceil((12 - 3) / 2)
    },
    {
      name: 'region',
      text: 'common.input_region',
      cols: Math.ceil((12 - 3) / 2),
      component: 'SelectRegion'
    },
    {
      name: 'address1',
      text: 'common.input_address_1'
    },
    {
      name: 'address2',
      text: 'common.input_address_2'
    }
  ],
  orderInfo: [
    {
      name: 'currency',
      text: 'common.input_currency',
      required: true,
      cols: Math.ceil((12 - 3) / 2),
      component: 'SelectCurrency'
    },
    {
      name: 'orderDate',
      text: 'order.order_order-date',
      required: true,
      cols: Math.ceil((12 - 3) / 2) - 1,
      component: 'NormalDatePicker'
    },
    {
      name: 'deliveryDate',
      text: 'order.order_suggested-loading-date',
      cols: Math.ceil((12 - 3) / 2) - 1,
      component: 'NormalDatePicker'
    }
  ]
}

export default { detail }
